import { Skeleton, Stack, styled } from "@mui/material";
import React from "react";

const AwardsCardItem = styled(Skeleton)(
    ({ theme }) => `
        max-width: calc(50% - 8px);
        height: 270px;
        flex: 0 0 calc(50% - 8px);
        borderRadius: 10px; 
        margin-top: ${theme.spacing(2)}; 
    `
)


export function AwardsCardLoader() {

    return (
        <Stack justifyContent="space-between" direction="row" sx={{width: "100%"}}>
            <AwardsCardItem variant="rounded" />
            <AwardsCardItem variant="rounded" />
        </Stack>
    )
}

